<template>
  <div class="md:block hidden">
     <div class="fixed-bottom-service">
    <div class="service-container relative flex flex-col items-center" @click="handleClick">
      <!-- 弹窗：背景图整体承载电话信号效果 -->
      <div
        v-if="show"
        class="service-popup absolute bottom-[90px] left-1/2 -translate-x-1/2 w-[280px] rounded-3xl transition-all duration-300 origin-bottom"
        :class="show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'">

        <!-- 背景图作为弹窗整体底图 -->
        <img
          src="@/assets/home/popup_bg.png"
          alt="服务热线弹窗背景"
          class="w-full h-full object-cover block">

        <!-- 文字内容覆盖在背景图上 -->
        <div class="absolute inset-0 flex flex-col justify-end px-5 py-5 text-white">
          <div class="text-center mt-1">
            <div class="font-bold text-lg text-black">服务热线</div>
            <div class="text-2xl font-bold tracking-wider mt-1 text-[#41B56F]">13121570328</div>
          </div>

          <div class="flex items-center gap-3 mb-2">
            <div class="bg-white p-1 rounded flex-shrink-0">
              <img
                src="@/assets/home/qr.jpg"
                alt="客服二维码"
                class="w-[60px] h-[60px]">
            </div>
            <div class="text-[#666] text-xs leading-relaxed">
              <p>扫一扫关注公众号</p> 
              <p class="mt-1">或直接拨打客服热线沟通</p>
            </div>
          </div>
        </div>

        <!-- 向下边框三角（用border绘制，不是纯色方块旋转） -->
        <!-- <div class="popup-arrow"></div> -->
      </div>

      <!-- 按钮 -->
      <img
        src="@/assets/home/Group_19.png"
        alt="新发现的低温型草菇"
        class="w-[72px] h-[72px] cursor-pointer select-none">
    </div>
  </div>
  </div>
 
</template>

<script>
export default {
  name: 'RightBottomService',
  data() {
    return {
      show: false
    }
  },
  methods: {
    handleClick() {
      this.show = !this.show
    }
  }
}
</script>

<style scoped>
.fixed-bottom-service {
  position: fixed;
  right: 15%;
  bottom: 30px;
  z-index: 9999;
}

.service-popup {
  z-index: 10000;
}

/* 向下的边框三角，border画法，和弹窗底色一致 */
.popup-arrow {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 14px;
  height: 14px;
  background: white;
  border-right: 2px solid #e5e7eb;
  border-bottom: 2px solid #e5e7eb;
  z-index: 11;
}
</style>
